import { useEffect } from "react";
import { api } from "@/lib/api";

// Injects admin-configured scripts into <head> and end of <body>.
// Runtime injection — visible in DOM (Inspect Element), fires analytics
// correctly. For raw view-source we'd need SSR.
function injectRawHTML(container, html, marker) {
  // Clean previous
  container.querySelectorAll(`[data-injected="${marker}"]`).forEach((n) => n.remove());
  if (!html) return;

  const tmpl = document.createElement("template");
  tmpl.innerHTML = html;
  Array.from(tmpl.content.childNodes).forEach((node) => {
    if (node.nodeType === 1) {
      // Re-create <script> nodes so they execute
      if (node.tagName === "SCRIPT") {
        const s = document.createElement("script");
        for (const attr of node.attributes) s.setAttribute(attr.name, attr.value);
        s.text = node.textContent;
        s.setAttribute("data-injected", marker);
        container.appendChild(s);
      } else {
        node.setAttribute && node.setAttribute("data-injected", marker);
        container.appendChild(node);
      }
    } else if (node.nodeType === 3) {
      // ignore stray text
    }
  });
}

export default function SiteScripts() {
  useEffect(() => {
    let cancelled = false;
    api.get("/site-settings").then(({ data }) => {
      if (cancelled) return;
      injectRawHTML(document.head, data.head_script || "", "site-head");
      injectRawHTML(document.body, data.footer_script || "", "site-footer");
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return null;
}
